/**
 * Muted platform tints — same spirit as sage (#7A9488), avoids neon brand blues/reds in-app.
 */
export const SOFT_PLATFORM_ICON: Record<string, string> = {
  linkedin: '#708FA3',
  facebook: '#758AA5',
  instagram: '#B38492',
  twitter: '#7FA3B5',
  pinterest: '#A67C82',
};

export function softPlatformIcon(platformId: string): string {
  return SOFT_PLATFORM_ICON[platformId] ?? '#7A9488';
}

/** Progress-bar segments (still distinguishable, low saturation) */
export const SOFT_PLATFORM_BAR_CLASS: Record<string, string> = {
  linkedin: 'bg-[#8DA8A0]',
  facebook: 'bg-[#7F96A8]',
  instagram: 'bg-[#A898A0]',
  twitter: 'bg-[#7FA8B0]',
  pinterest: 'bg-[#A89090]',
};

export function softPlatformBarClass(platformId: string): string {
  return SOFT_PLATFORM_BAR_CLASS[platformId] ?? 'bg-[#8DA8A0]';
}
